import React from 'react';
import { Button } from '../../components/Button';
interface Product {
  name: string;
  price: string;
  image: string;
  hasConfigurator?: boolean;
  href?: string;
  badge?: string;
}
/** Inlined product data — owned by this page only, not shared. */
const PRODUCTS: Product[] = [{
  name: 'Gen3 PSS-Gloves USAT',
  price: '$69.00',
  image: 'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png',
  hasConfigurator: true,
  href: '/m5/EPRO%2029943--Official-Daedo-Gen3-Gloves.html'
}, {
  name: 'Gen3 E-Foot Gear',
  price: '$110.84',
  image: 'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg',
  hasConfigurator: true,
  href: '/m5/EPRO%2029039--gen3-e-foot-gear.html'
}, {
  name: 'Gen2 Transmitter Charger',
  price: '$55.00',
  image: 'https://cdn.magicpatterns.com/uploads/qEV6XsHhowYMSa1F9qrPwc/Gen2_Transmitter_Charger.jpg'
}, {
  name: 'Gen2 W.T. Software',
  price: '$99.00',
  image: 'https://cdn.magicpatterns.com/uploads/orVwRQoYnnfYKgyRtLXkKq/Gen2_W.T._Software.jpg'
}, {
  name: 'Gen2 Judge Box (Refurbished)',
  price: '$580.00',
  image: 'https://cdn.magicpatterns.com/uploads/bS347spy52LoYXHH7zr4qL/Gen2_Judge_Box_(Refurbished)_Same_Warranty.jpg'
}, {
  name: 'Gen2 Receiver',
  price: '$390.00',
  image: 'https://cdn.magicpatterns.com/uploads/w3Q65FCerZEu2ek6y4Xdyo/Gen2_Receiver.jpg'
}, {
  name: 'Gen2 E-HeadGear',
  price: '$399.00',
  image: 'https://cdn.magicpatterns.com/uploads/oEDj2ZvCJJBgsVECUR8bR3/Gen2_E-HeadGear.jpg',
  hasConfigurator: true
}, {
  name: 'Gen2 Head Transmitter',
  price: '$390.00',
  image: 'https://cdn.magicpatterns.com/uploads/keKg2f8ApxK9KnFdbJLkPa/Gen2_Head_Transmitter.jpg'
}];
/**
 * Product listing grid for the Daedo PSS Systems category page.
 * Data is inlined above; no shared product list.
 */
export function ProductGrid() {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-212">
      {PRODUCTS.map((product, index) => {
      const href = product.href ?? '#';
      return <article key={`${product.name}-${index}`} className="group flex flex-col bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-id="element-213">
            <a href={href} className="block relative aspect-square bg-gray-50 overflow-hidden" data-id="element-214">
              {product.badge && <span className="absolute top-3 left-3 bg-red-600 text-white text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded" data-id="element-215">
                  {product.badge}
                </span>}
              <img src={product.image} alt={product.name} className="block w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" data-id="element-216" />
            </a>

            <div className="flex flex-col flex-grow p-5" data-id="element-217">
              <a href={href} className="flex-grow" data-id="element-218">
                <h3 className="text-base font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2 min-h-[3rem]" data-id="element-219">
                  {product.name}
                </h3>
              </a>
              <div className="mb-4" data-id="element-220">
                <p className="text-xl font-black text-gray-900" data-id="element-221">
                  {product.price}
                </p>
              </div>
              {product.hasConfigurator ? <Button href={href} variant="primary" className="w-full !py-2 text-sm mt-auto" data-id="element-222">
                  Select Options
                </Button> : <Button href={href} variant="primary" className="w-full !py-2 text-sm bg-red-600 hover:bg-red-700 focus:ring-red-600 mt-auto" data-id="element-223">
                  Add To Cart
                </Button>}
            </div>
          </article>;
    })}
    </div>;
}